import * as vybava from "./incl/vybava.js";
import * as detail from "./page/detail.js";
import * as uvod from "./page/uvod.js";
import * as navigace from "./incl/navigace.js";
/*
import * as produkty from "./incl/produkty.js";
import * as uvod from "./page/uvod.js";
import * as detail from "./page/detail.js";
import * as kosik from "./page/kosik.js";
import * as kategorie from "./page/kategorie.js";
import * as iframe from "./incl/iframe.js";
 */
/*
if (process.env.NODE_ENV == "development") {

}
*/

//--povoli konzoli
var Url = new URL(window.location.href);

if (process.env.NODE_ENV == "development" || Url.searchParams.has("debug")) {
  Lc.zobraz({ version: "2.0.2", appName: "rpd-auto" });
}

$(document).ready(function() {
  navigace.upravNavigaci();

  let $vybava = false;
  if (window.location.pathname.startsWith("/admin/bazar/") || $vybava) {
    let c = $("#dvVybava");
    if (c.length) {
      vybava.nactiFormular(c);
    }
  } else if ($("body").attr("id") == "bdBazar") {
    detail.zobrazSlider();
    detail.fotogalerie();
  } else if ($("body").attr("id") == "bdUvod") {
    uvod.upravStranku();
  }
});
